import HEADER_IMAGE_CONFLUENCE_DARK from './dark/confluence-crossflow-dark';
import HEADER_IMAGE_JPD_DARK from './dark/jpd-crossflow-dark';
import HEADER_IMAGE_JSM_DARK from './dark/jsm-crossflow-dark';
import HEADER_IMAGE_CONFLUENCE_LIGHT from './light/confluence-crossflow-light';
import HEADER_IMAGE_JPD_LIGHT from './light/jpd-crossflow-light';
import HEADER_IMAGE_JSM_LIGHT from './light/jsm-crossflow-light';
import HEADER_IMAGE_MULTI_PRODUCT_UPGRADES from './light/multi-product-upgrades-banner';
import HEADER_IMAGE_TEAM_25_ROVO from './light/team-twenty-five-rovo-ipm';
import HEADER_IMAGE_ROVO_DEV_ADOPTION_LIGHT from './light/rovo-dev-adoption-light';
import HEADER_IMAGE_ROVO_DEV_ADOPTION_DARK from './dark/rovo-dev-adoption-dark';
import { type JSX } from 'react/jsx-runtime';

const HEADER_IMAGES_CONFLUENCE = {
	light: HEADER_IMAGE_CONFLUENCE_LIGHT,
	dark: HEADER_IMAGE_CONFLUENCE_DARK,
	alt: 'Multiple people collaborating and commenting on the same page at the same time',
};

const HEADER_IMAGES_JPD = {
	light: HEADER_IMAGE_JPD_LIGHT,
	dark: HEADER_IMAGE_JPD_DARK,
	alt: 'An idea in Jira Product Discovery automatically turning into an Epic in Jira',
};

const BACKGROUND_IMAGES_JSM = {
	light: HEADER_IMAGE_JSM_LIGHT,
	dark: HEADER_IMAGE_JSM_DARK,
	alt: 'Requests from Slack, Teams and email turning into a Jira Service Management request automatically',
};

const HEADER_IMAGES_TEAM_25_ROVO = {
	light: HEADER_IMAGE_TEAM_25_ROVO,
	dark: HEADER_IMAGE_TEAM_25_ROVO,
	alt: 'Team 25 Rovo IPM',
};

const HEADER_IMAGES_MULTI_PRODUCT_UPGRADES = {
	light: HEADER_IMAGE_MULTI_PRODUCT_UPGRADES,
	dark: HEADER_IMAGE_MULTI_PRODUCT_UPGRADES,
	alt: '',
};

const HEADER_IMAGE_ROVO_DEV_ADOPTION = {
	light: HEADER_IMAGE_ROVO_DEV_ADOPTION_LIGHT,
	dark: HEADER_IMAGE_ROVO_DEV_ADOPTION_DARK,
	alt: 'Rovo Dev Adoption',
};

export const HEADER_IMAGES_MAP: {
	Confluence: {
		light: () => JSX.Element;
		dark: () => JSX.Element;
		alt: string;
	};
	'Jira Product Discovery': {
		light: () => JSX.Element;
		dark: () => JSX.Element;
		alt: string;
	};
	'Jira Service Management': {
		light: () => JSX.Element;
		dark: () => JSX.Element;
		alt: string;
	};
	'Rovo Team 25': {
		light: () => JSX.Element;
		dark: () => JSX.Element;
		alt: string;
	};
	'Multi Product Upgrades': {
		light: () => JSX.Element;
		dark: () => JSX.Element;
		alt: string;
	};
	'Rovo Dev Adoption': {
		light: () => JSX.Element;
		dark: () => JSX.Element;
		alt: string;
	};
} = {
	Confluence: HEADER_IMAGES_CONFLUENCE,
	'Jira Product Discovery': HEADER_IMAGES_JPD,
	'Jira Service Management': BACKGROUND_IMAGES_JSM,
	'Rovo Team 25': HEADER_IMAGES_TEAM_25_ROVO,
	'Multi Product Upgrades': HEADER_IMAGES_MULTI_PRODUCT_UPGRADES,
	'Rovo Dev Adoption': HEADER_IMAGE_ROVO_DEV_ADOPTION,
};
